import { Pipe, PipeTransform } from '@angular/core'
import { OrderTermEnum } from '@modules/orders-module/enums/order-term.enum'

@Pipe({
	name: 'titleOrderTerm',
})
export class TitleOrderTermPipe implements PipeTransform {
	protected readonly orderTermEnum: typeof OrderTermEnum = OrderTermEnum

	private _checkTimeInForce(timeInForce: OrderTermEnum, isExtendedHours: boolean): OrderTermEnum {
		if (timeInForce === this.orderTermEnum.DAY && isExtendedHours) return this.orderTermEnum.DAY_PLUS

		return timeInForce
	}

	transform(timeInForce: OrderTermEnum | undefined, extendedHours: boolean | undefined): OrderTermEnum | string {
		if (!timeInForce) return ''
		return this._checkTimeInForce(timeInForce, !!extendedHours)
	}
}
